import React from 'react';
import { Grid, Box } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';

type EmailPasswordFieldsProps = {
  email?: string;
  password?: string;
};
const EmailPasswordFields = (props: EmailPasswordFieldsProps) => {
  const { email, password } = props;


  const [emailValue, setEmailValue] = React.useState(email || '');

  return (
    <Grid display={'flex'} gap={5} flexDirection={'column'} p={5}>
      <Grid item xs={12} sm={6} display={'flex'} flexDirection={'column'}>
        <label
          htmlFor='email'
          style={{
            fontWeight: 700,
            fontSize: '18px',
            color: '#000000',
            marginLeft: '10px',
          }}>
          Email Address here
        </label>
        <Grid display={'flex'} gap={2} alignItems={'center'} flex={1}>
          <Box sx={{ flexGrow: 1 }}>
            <CustomTextField
              name='email'
              sx={{ width: '100%', maxWidth: '654px' }}
              value={emailValue}
              // defaultValue={"firstName" || ""}
              onChange={() => { }}
            />
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EmailPasswordFields;
